import uniAdminApi from "./api";

const locationService = {
  getCountries: async () => {
    const res = await uniAdminApi.get("/countries/list-all");
    return res.data;
  },

  getCitiesByCountry: async (countryId) => {
    const res = await uniAdminApi.get(`/cities/by-country/${countryId}`);
    return res.data;
  },
};

export default locationService;
